import React, { useEffect, useState } from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ShieldCheck, Lock, Shield } from 'lucide-react';
export function Offer() {
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return 10 * 60; // Reset to 10 minutes when it reaches 0
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <Section bgColor="white" id="offer" data-id="element-128">
      <div className="max-w-5xl mx-auto bg-brand-cream rounded-sm shadow-xl overflow-hidden border border-brand-beige" data-id="element-129">
        <div className="flex flex-col md:flex-row" data-id="element-130">
          {/* Left: Image & Value */}
          <div className="flex-1 p-8 md:p-12 bg-brand-blush/30 flex flex-col justify-center items-center text-center border-b md:border-b-0 md:border-r border-brand-beige pt-[32px] pb-[32px]" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/jZwaqfw8my1sAr2YZDewbV/ChatGPT_Image_Mar_25,_2026,_07_55_45_PM_(1).webp" alt="Viaje a tu Interior Bundle" className="w-full max-w-xs rounded-sm shadow-lg mb-8 aspect-[4/5] object-cover" data-id="element-132" />
          </div>

          {/* Right: Pricing & CTA */}
          <div className="flex-1 p-8 md:p-12 flex flex-col justify-center" data-id="element-133">
            <div className="inline-block px-4 py-1.5 bg-brand-violet text-white text-xs font-bold uppercase tracking-widest rounded-sm self-start mb-6" data-id="element-134">
              50% de Descuento Hoy
            </div>

            <h2 className="text-3xl font-serif mb-2 text-brand-dark" data-id="element-135">
              Viaje a tu Interior: El diario para sanar, entenderte y descubrir
              tu fuerza como mujer
            </h2>

            <div className="mb-8 text-center md:text-left" data-id="element-136">
              <div className="flex items-center justify-center md:justify-start gap-3" data-id="element-137">
                <span className="text-lg text-brand-light line-through" data-id="element-138">
                  $30.000 ARS
                </span>
                <span className="text-brand-light" data-id="element-139">→</span>
                <span className="text-3xl md:text-4xl font-serif font-bold text-brand-dark" data-id="element-140">
                  $14.999 ARS
                </span>
              </div>
            </div>

            <Button className="w-full text-lg py-5 mb-6" data-id="element-141">
              Agregar al carrito
            </Button>

            {/* Urgency Block */}
            <div className="mb-6 flex flex-col items-center md:items-start gap-3" data-id="element-142">
              {/* Viewing Now Badge */}
              <div className="inline-flex items-center px-4 py-2 text-brand-dark rounded-lg shadow-md animate-pulse bg-[#B39FCB]" data-id="element-143">
                <span className="text-sm font-medium text-[#000000]" data-id="element-144">
                  🔥 31 mujeres están viendo esto ahora
                </span>
              </div>

              {/* Countdown Timer */}
              <div className="w-full rounded-xl p-4 shadow-lg bg-[#B39FCB]" data-id="element-145">
                <h3 className="text-sm font-bold text-center mb-3 text-[#000000]" data-id="element-146">
                  ✨ Oferta por tiempo limitado✨
                </h3>
                <div className="flex justify-center mb-2" data-id="element-147">
                  <div className="bg-black/20 rounded-lg px-6 py-3 border border-white/10" data-id="element-148">
                    <span className="text-3xl md:text-4xl font-mono font-bold tracking-wider text-[#070707]" data-id="element-149">
                      {formatTime(timeLeft)}
                    </span>
                  </div>
                </div>
                <p className="text-xs text-center text-[#252323]" data-id="element-150">
                  El precio sube cuando termine el contador
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3 text-sm text-brand-light" data-id="element-151">
              <div className="flex items-center gap-2" data-id="element-152">
                <Lock className="w-4 h-4 text-brand-violet" data-id="element-153" />
                <span className="text-[#4A4A4A]" data-id="element-154">
                  Pago seguro con Mercado Pago
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-155">
                <Shield className="w-4 h-4 text-brand-violet" data-id="element-156" />
                <span className="text-[#4A4A4A]" data-id="element-157">Garantía de 30 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}